import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const DownloadFilesHeader = ({
  filesVisible,
  filesTotal,
  loading,
}) => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <h2 className="page-title">
        <i className="far fa-file" />
        {intl.formatMessage({ defaultMessage: 'Requested files' })}
      </h2>
      <div className="header-actions users-actions">
        <div className="items-displaying users-displaying">
          {(!loading && filesTotal > 0) && (
            <span>
              {intl.formatMessage(
                { defaultMessage: '{filesVisible} of {filesTotal} files' },
                { filesVisible, filesTotal },
              )}
            </span>
          )}
        </div>
      </div>
    </header>
  );
};

DownloadFilesHeader.propTypes = {
  filesVisible: PropTypes.string.isRequired,
  filesTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default DownloadFilesHeader;
